function getFontSize(size) {
	if (size === 'small') return {header: 11, normal: 9};
	if (size === 'medium') return {header: 12, normal: 10};
	if (size === 'big') return {header: 13, normal: 11};
}

export function getPrintCSS(settings) {
    const fontSize = getFontSize(settings.fontSize);

    return `
        table,
        th,
        td {
            border: 1px solid black;
            border-collapse: collapse;
            text-align: center;
            -webkit-print-color-adjust: exact;
            font-size: ${fontSize.normal}px;
        }
        th,
        td {
            max-width: 200px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
        thead > tr {
            border: unset;
        }
        thead > tr > th {
            border: unset;
            padding: 1em 1em 1em 1em;
        }

        #container-table {
            border: unset;
            table-layout: fixed;
            width: 100%;
        }
        #container-table > tbody > tr > td {
            max-width: 100%;
            padding: 0px;
            overflow: visible;
            border: unset;
        }

        .oddsTable {
            width: 100%;
            margin-left: auto;
            margin-right: auto;
        }
        
        .rigaOrario td {
            text-align: left;
            background-color: black;
            color: #fff;
            font-size: 10px;
            font-weight: bold;
        }
        .rigaManifestazione td {
            text-align: left;
            background-color: gray;
            color: #fff;
            font-size: 10px;
            font-weight: bold;
        }
        .quota {
            max-width: 45px !important;
        }
        .headerPrincipale {
            background-color: rgb(211, 211, 211);
            font-weight: bold;
            -webkit-print-color-adjust: exact;
            font-size: ${fontSize.header}px !important;
            color: #000 !important;
        }
        .headerDescScomm {
            max-width: 160px !important;
        }
        .subHeader {
            background-color: rgb(211, 211, 211);
            font-weight: bold;
            -webkit-print-color-adjust: exact;
            color: #000 !important;
        }
        .rigaVuotaAliasDataOraEvento {
            background-color: #000 !important;
            -webkit-print-color-adjust: exact;
            color: #fff !important;
        }
        .hideme {
            display: none !important;
        }
        @page {
            size: ${settings.align === 'vertical' ? 'auto' : 'landscape'};
            margin-left: 0;
            margin-right: 0;
            margin: 1cm 0cm 1cm 0cm;
        }
        .spaceForHeader{
            padding-top: 3.35em;
            page-break-inside:avoid;
            page-break-after:auto;
        }
        @media screen {
            div.onlyprint{
                position: fixed;
                top: 0;
                left: 30px;
                width: 100%;
            }
        }
        @media print {
            div.onlyprint {
                position: fixed;
                top: 0;
                left: 30px;
                width: 100%;
            }
        }
        @media print {
            div.onlyprint1 {
                position: absolute;
                top: 0;
                left: 30px;
                width: 100%;
            }
        }

        @media print {
            table { page-break-after:auto; page-break-inside:avoid }
            tr    { page-break-inside:avoid; page-break-after:auto }
            td    { page-break-inside:avoid; page-break-after:auto }
            thead { display:table-header-group }
            tfoot { display:table-footer-group }
        }

        .floatLeft {
            float: left;
        }

        .floatRight {
            float: right;
        }

        .logosContainer {
            font-size: laarghe
        }

        .customerLogo {
            min-heigth: 30px;
            min-width: 120px;
            max-width: 2in;
            max-height: 35px;
        }

        .aamsLogo {
            width: auto;
            heigth: auto;
            max-width: 200px;
            max-height: 35px;
            marginRight: ${settings.logoOnAllPages ? 'unset' : '90px'};
        }
    `;
}
